import { cn } from '@workspace/ui/lib/utils'
import * as React from 'react'

export interface LabelValueProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Icon element to display */
  icon?: React.ReactNode
  /** Label text */
  label: string
  /** Value to display */
  value?: string | number | null
  /** Placeholder when value is empty */
  placeholder?: string
  /** Layout direction */
  direction?: 'horizontal' | 'vertical'
}

export const LabelValue = React.forwardRef<HTMLDivElement, LabelValueProps>(
  ({ icon, label, value, placeholder = '—', direction = 'vertical', className, ...props }, ref) => {
    const displayValue = value ?? placeholder

    if (direction === 'horizontal') {
      return (
        <div ref={ref} className={cn('flex items-center gap-1', className)} {...props}>
          {icon && <div className="text-muted-foreground shrink-0">{icon}</div>}
          <div className="flex items-center gap-2">
            <span className="text-sm text-muted-foreground">{label}:</span>
            <span className="text-white font-medium">{displayValue}</span>
          </div>
        </div>
      )
    }

    return (
      <div ref={ref} className={cn('flex items-start gap-3', className)} {...props}>
        {icon && <div className="text-muted-foreground mt-0.5 shrink-0">{icon}</div>}
        <div className="space-y-1">
          <div className="text-sm text-muted-foreground">{label}</div>
          <div className="text-white">{displayValue}</div>
        </div>
      </div>
    )
  }
)

LabelValue.displayName = 'LabelValue'
